import { connect } from 'react-redux'

import { getPermission } from 'reduxpath/ducks/Impersonate'

import Item from './units'

const mapStateToProps = state => ({
  userEmail: state.Auth.me.user.email,
})

const mapDispatchToProps = dispatch => ({
  goesToPlatform(profileId, userEmail) {
    return () => {
      dispatch(getPermission(profileId, userEmail))
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Item)
